import React, { useMemo } from 'react';

import { RuleDesc } from './ChatMessage.styles';

export default ({children}) => {
    let content = useMemo(() => {
        return children.split('\n').map((item, i) => {
            let content = item.trim();
            content = content.replace(/</gi, '&lt;');
            content = content.replace(/>/gi, '&gt');
            content = content.replace(/\*(.*?)\*/gi, '<b>$1</b>');
            content = content.replace(/_(.*?)_/gi, '<i>$1</i>');
            content = content.replace(/~(.*?)~/gi, '<s>$1</s>');
            content = content.replace(/\$color:([a-z]+|#(?:[0-9a-f]{3}){1,2})\s*?(.*?)\s*?\$color/gi, '<span style="color:$1">$2</span>');

            return content ? <p key={i} dangerouslySetInnerHTML={{__html:content}} /> : <br key={i}/>
        });
    }, [children]);

    return <RuleDesc>
        {content}
    </RuleDesc>
};